import { render, staticRenderFns } from "./SimpleTeacherCard.vue?vue&type=template&id=52b777b4&scoped=true&"
import script from "./SimpleTeacherCard.vue?vue&type=script&lang=js&"
export * from "./SimpleTeacherCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTeacherCard.vue?vue&type=style&index=0&id=52b777b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b777b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VHover,VIcon,VRow})
